// 英語の表（鍵は日本語の文言そのまま。足りない鍵は tools/devtest/i18n_keys.py で分かる）。
// パラメータの名前は仮（用語を決めたら直す）。
export const en: Record<string, string> = {
  "歌のトラック": "Vocal track",
  "音符を描いて歌わせる": "Draw notes and have them sung",
  "伴奏のトラック": "Backing track",
  "音声ファイルを選択（画面にドロップしても追加できます）": "Choose an audio file (or drop one onto the window)",
  "ドロップすると伴奏トラックとして追加します": "Drop to add the audio file as a backing track",
  "音声ファイル（wav・mp3・flac など）をドロップしてください": "Drop an audio file (wav, mp3, flac, …)",
  "名前を変える": "Rename",
  "トラックを削除": "Delete track",
  "⌘Z で戻せます": "⌘Z to undo",
  "歌のトラックは 1 本は残す必要があります（ピアノロールで使うため）": "At least one vocal track must remain (the piano roll needs one)",
  "トラックを削除しました: {name}（⌘Z で戻せます）": "Deleted track: {name} (⌘Z to undo)",
  "トラック {n}": "Track {n}",
  "読み込み中: {name}": "Loading: {name}",
  "音声ファイルを読めませんでした: {name}（{e}）": "Couldn't read the audio file: {name} ({e})",
  "伴奏トラックを追加しました: {name}（{sec} 秒）": "Added backing track: {name} ({sec} s)",
  "クリック・ドラッグ: 再生位置を移動": "Click/drag: move the playhead",
  "ドラッグ: 左右に移動　⌘/Ctrl+ホイール・ピンチ: 時間方向の拡大縮小": "Drag: scroll sideways　⌘/Ctrl+wheel or pinch: zoom time",
  "ドラッグ: 伴奏を移動（スナップしない）　右クリック: 名前を変える・削除": "Drag: move the backing (no snap)　Right-click: rename/delete",
  "ドラッグ: トラックを移動（音符とパラメータの曲線も一緒に）　⌥+ドラッグ: スナップしない　右クリック: 名前を変える・削除": "Drag: move the track (notes and curves too)　⌥+drag: no snap　Right-click: rename/delete",
  "ドラッグ: 伴奏の再生範囲を詰める・戻す（スナップしない）": "Drag: trim or restore the backing (no snap)",
  "ドラッグ: トラックの範囲を変更（範囲の外の音符は歌わない）　⌥+ドラッグ: スナップしない": "Drag: resize the track range (notes outside are not sung)　⌥+drag: no snap",
  "クリック・ドラッグ: ピアノロールの表示位置を移動　ホイール: 上下　Shift+ホイール: 左右　⌘/Ctrl+ホイール・ピンチ: 拡大縮小　音声ファイルをドロップ: 伴奏トラックを追加": "Click/drag: move the piano-roll view　Wheel: up/down　Shift+wheel: sideways　⌘/Ctrl+wheel or pinch: zoom　Drop audio: add a backing track",
  "ダブルクリック: 名前を変える": "Double-click: rename",
  "音量": "Volume",
  "パン": "Pan",
  "中央": "Center",
  "左": "L",
  "右": "R",
  "ミュート": "Mute",
  "ソロ": "Solo",
  "ドラッグ: 音素の境界を移動（休符の後の先頭は前の休符の中まで伸ばせます。フレーズの終わりは動きません）　ダブルクリック: 元に戻す": "Drag: move a phoneme boundary (a start after a rest can extend into that rest; phrase ends are fixed)　Double-click: reset",
  "音素": "Phonemes",
  "波形": "Waveform",
  "ドラッグで高さを変える": "Drag to resize",
  "閉じる（Esc）": "Close (Esc)",
  "書き出し": "Export",
  "ファイル名": "File name",
  "形式": "Format",
  "チャンネル": "Channels",
  "ステレオ": "Stereo",
  "モノ（パンは掛けない）": "Mono (no panning)",
  "ビット深度": "Bit depth",
  "32 bit 浮動小数": "32-bit float",
  "無題": "Untitled",
  "ミックスを書き出す": "Export mix",
  "再生と同じ音（ミュート・ソロ、トラックの音量とパン、エフェクターを反映）": "Same as playback (mute/solo, track volume and pan, effects)",
  "トラックを別々に書き出す": "Export tracks separately",
  "選んだトラックを書き出す（{n} ファイル）": "Export selected tracks ({n})",
  "書き出し中…": "Exporting…",
  "レンダリング中（残り {n} フレーズ）": "Rendering ({n} phrases left)",
  "エンジンにつながっていないので書き出せません。": "Can't export: the engine isn't connected.",
  "連続音の歌詞 {n} 個を単独音に直しました": "{n} VCV lyrics were converted to CV",
  "ブレスの記号 {n} 個を休符にしました": "{n} breath marks became rests",
  "読めない歌詞 {n} 個を休符にしました: {list}": "{n} unreadable lyrics became rests: {list}",
  "ブレスを {n} 個入れました": "{n} breaths added",
  "書き出しました: {names}": "Exported: {names}",
  "書き出しに失敗しました: {e}": "Export failed: {e}",
  "設定": "Settings",
  "画面の言語": "Language",
  "変更するとページを再読み込みします（編集内容は自動保存から復元されます）": "Changing it reloads the page (your work continues from the autosave)",
  "アクセントカラー": "Accent color",
  "音符・選んだ所・つまみの色。トラックの色もここから作ります": "Color of notes, selections and controls. Track colors are derived from it",
  "好きな色を選ぶ": "Pick any color",
  "自由選択": "Custom",
  "既定に戻す": "Reset",
  "mel の配色": "Mel colormap",
  "下のパネルの mel の色": "Colors of the mel panel",
  "エンジン": "Engine",
  "GPU で計算する（実験的・Chrome 向け。変更は読み込み直しで反映）": "Compute on the GPU (experimental, for Chrome; takes effect after a reload)",
  "Safari では使えません（WebGPU 入りの部品を読むとページが読み込み直されるため）": "Not available in Safari (loading the WebGPU build makes Safari reload the page)",
  "このブラウザは WebGPU に対応していません": "This browser does not support WebGPU",
  "この環境では GPU を使えません（WebGPU の準備ができません）": "The GPU is not available here (WebGPU could not be set up)",
  "VocaTab のプロジェクト": "VocaTab project",
  "（未保存）": " (not saved)",
  "編集はブラウザの中に自動で保存しています（読み込み直しても続きから）": "Edits are autosaved in the browser (reloading continues where you left off)",
  "自動保存 {time}": "Autosaved {time}",
  "自動保存に失敗: {e}": "Autosave failed: {e}",
  "新規": "New",
  "サンプル曲から始める": "Start from the sample song",
  "開く": "Open",
  "⌘O　.svsproj か、音声も含めた .zip": "⌘O　.svsproj or a .zip with audio",
  "保存": "Save",
  "名前を付けて保存": "Save as",
  "音声も含めて書き出す": "Export with audio",
  "伴奏の音声もまとめた .zip": "A .zip including backing audio",
  "楽譜を読み込む": "Import score",
  "MusicXML（.musicxml・.xml・.mxl）・UST。新しい歌のトラックにする": "MusicXML (.musicxml, .xml, .mxl) or UST, as a new vocal track",
  "今のプロジェクトを閉じて、サンプル曲から始めますか？（保存していない変更は消えます）": "Close this project and start from the sample song? (Unsaved changes will be lost)",
  "新しいプロジェクトにしました": "Started a new project",
  "音声も含めたプロジェクト": "Project with audio",
  "開きました: {name}": "Opened: {name}",
  "開けませんでした: {name}": "Couldn't open: {name}",
  "伴奏の音声が見つかりません": "Backing audio not found",
  "プロジェクトファイルには伴奏の音声は含まれていません。元の音声ファイルを選択してください（複数選択可。内容で照合するため、移動や名前変更があっても問題ありません）。": "Project files don't contain the backing audio itself. Choose the original audio files (you can pick several; they are matched by content fingerprint, so moved or renamed files are fine).",
  "ファイルを選ぶ": "Choose files",
  "あとで（音を出さずに続ける）": "Later (continue without audio)",
  "伴奏を再リンクしました: {names}": "Relinked backing audio: {names}",
  "リンクしました: {names}": "Linked: {names}",
  "一致するファイルが見つかりませんでした: {names}": "No matching files: {names}",
  "楽譜を読めませんでした: {name}": "Couldn't read the score: {name}",
  "楽譜を読み込みました: {name}（{tracks} トラック、{notes} 音符、テンポ {bpm}）": "Imported score: {name} ({tracks} tracks, {notes} notes, tempo {bpm})",
  "　注意: {w}": "　Note: {w}",
  "保存しました": "Saved",
  "保存しました: {name}": "Saved: {name}",
  "保存できませんでした: {e}": "Couldn't save: {e}",
  "ダウンロードしました": "Downloaded",
  "音声も含めて書き出しました: {name}（{mb} MB）": "Exported with audio: {name} ({mb} MB)",
  "ルーム": "Room",
  "ホール": "Hall",
  "プレート": "Plate",
  "アリーナ": "Arena",
  "オン/オフ": "On/off",
  "イコライザー": "Equalizer",
  "ローカット": "Low cut",
  "周波数": "Frequency",
  "ゲイン": "Gain",
  "幅（Q）": "Width (Q)",
  "空いている所をダブルクリックでポイントを追加。ドラッグで移動、ポイントの上でホイールを回すと幅（Q）を調整、右クリックまたは Delete で削除します。⌐ はローカットです。":
    "Double-click an empty spot to add a point. Drag to move, wheel over a point to adjust width (Q), right-click or Delete to remove. ⌐ is the low cut.",
  "濁り": "Mud",
  "こもり": "Boxy",
  "鼻": "Nasal",
  "抜け": "Pres.",
  "歯擦音": "Sibil.",
  "空気": "Air",
  "合成が完了すると、ここに声のスペクトルが表示されます": "The voice spectrum appears here once rendering is done",
  "幅 {q}": "width {q}",
  "ローカット: {f}": "Low cut: {f}",
  "ポイントは {n} 個まで追加できます": "Up to {n} points",
  "このポイントを削除": "Remove this point",
  "コンプレッサー": "Compressor",
  "スレッショルド {db} dB": "Threshold {db} dB",
  "スレッショルド": "Threshold",
  "アタック": "Attack",
  "レシオ": "Ratio",
  "リバーブ": "Reverb",
  "始まり": "Start",
  "量": "Amount",
  "長さ": "Length",
  "長さ {d} 秒 · 量 {w} % · 始まり {p} ms": "Length {d} s · Amount {w} % · Start {p} ms",
  "ポイントをドラッグして、プリディレイ・ミックス量・残響の長さを調整します。ダブルクリックで種類の値に戻ります。": "Drag the points to adjust pre-delay, mix amount and tail length. Double-click a point to reset it to the type's value.",
  "{name}: {value}（上下にドラッグで回す、⇧ で細かく、ダブルクリックで戻す）": "{name}: {value} (drag up/down, ⇧ for fine, double-click to reset)",
  "Space: 再生・一時停止　1: 選択　2: 鉛筆　3: ピッチのペン　Delete: 削除　⌘C / ⌘V: コピー / 再生位置に貼り付け　⌘Z / ⇧⌘Z: 取り消し / やり直し　↑↓: 半音（⇧ でオクターブ）": "Space: play/pause　1: select　2: pencil　3: pitch pen　Delete: delete　⌘C / ⌘V: copy / paste at playhead　⌘Z / ⇧⌘Z: undo / redo　↑↓: semitone (⇧ octave)",
  "{n} 個の音符をコピーしました": "{n} notes copied",
  "{n} 個の音符を切り取りました": "{n} notes cut",
  "{n} 個の音符を再生位置に貼り付けました": "{n} notes pasted at the playhead",
  "コピーする音符を選んでください": "Select notes to copy first",
  "貼り付ける音符がありません（先に ⌘C でコピー）": "Nothing to paste (copy notes with ⌘C first)",
  "パラメータ": "Parameters",
  "音素のタイミング": "Phoneme timing",
  "実験版": "experimental",
  "モック": "mock",
  "エンジン未接続（モック）": "Engine not connected (mock)",
  "レンダリング中 {done}/{all} フレーズ": "Rendering {done}/{all} phrases",
  "レンダリング完了": "Rendered",
  "レンダリング完了（待機中）": "Rendered (engine idle)",
  "モデルを読み込み中 {p}%（{mb} / {total} MB）": "Loading models {p}% ({mb} / {total} MB)",
  "選択 (1)": "Select (1)",
  "音符を描く (2)": "Draw notes (2)",
  "ピッチのペン (3)": "Pitch pen (3)",
  "ピッチの線": "Pitch line",
  "再生・一時停止（Space）": "Play/pause (Space)",
  "テンポは 20〜400 の数で入れてください（{s}）": "Enter a tempo between 20 and 400 ({s})",
  "拍子は「3」「6/4」のように、4 分音符を 1 拍として入れてください（{s}）": "Enter the time signature like \"3\" or \"6/4\", counting quarter notes as beats ({s})",
  "1 小節の拍の数は 1〜16 です": "Beats per bar must be 1–16",
  "前回の続きから開きました（{at} に自動保存）": "Resumed from your last session (autosaved {at})",
  "自動保存を読めませんでした: {e}": "Couldn't read the autosave: {e}",
  "計算中…（フレーズの合成が終わると表示されます）": "Computing… (appears once the engine renders the phrase)",
  "{sec} s（{fr} フレーム）　{hz} Hz（bin {bin}）　{val}": "{sec} s (frame {fr})　{hz} Hz (bin {bin})　{val}",
  "① ボコーダに入れる mel（postfilter 後）": "① Mel fed to the vocoder (after postfilter)",
  "② ボコーダの出力の mel（声の調整なし）": "② Mel of the vocoder output (no voice adjustments)",
  "③ 声の調整を掛けた音の mel": "③ Mel of the output with voice adjustments",
  "ボコーダの入力": "Vocoder input",
  "ボコーダの出力": "Vocoder output",
  "声の調整後": "After voice adj.",
  "エンジンの mel。② は声の調整を掛けない音（②③ はオンのときだけ作る）": "Engine mel. ② is the sound without voice adjustments (② and ③ are computed only when on)",
  "仮のデータです（エンジン未接続）。オフの行は計算しません": "Placeholder data (engine not connected). Rows that are off aren't computed",
  "（伸ばし）": "(held)",
  "{n} 個": "{n} notes",
  "{ph} · {pitch} · {beats} 拍": "{ph} · {pitch} · {beats} beats",
  "{lyric} ほか（まとめて変える）": "{lyric} and others (changed together)",
  "抑揚": "Inflection",
  "AI が付けた抑揚（しゃくり・こぶし・音の移り方など、音符の高さからのずれ）の倍率（0 で音符の高さどおり）。ダブルクリックで 1 に戻す":
    "Scales the AI's pitch inflection (scoops, turns, transitions — the deviation from the note pitch). 0 = exactly the note pitch. Double-click to reset to 1",
  "ビブラート": "Vibrato",
  "AI が付けたビブラートの幅の倍率（0 で消える）。ダブルクリックで 1 に戻す": "Scales the AI vibrato depth (0 removes it). Double-click to reset to 1",
  "ピッチ": "Pitch",
  "抑揚とビブラートを取り直す": "Retake the inflection and vibrato",
  "声": "Voice",
  "息づかいや音色の細部を取り直す": "Retake breath and timbre details",
  "最初のテイク": "First take",
  "{n} 回目": "Take {n}",
  "{n} 個をリテイクしました": "{n} notes retaken",
  "この音符だけ AI の生成をやり直す": "Regenerate the AI output for these notes only",
  "リテイク": "Retake",
  "一つ前のテイクに戻す": "Back to the previous take",
  "一つ前": "Back",
  "最初のテイク（初期の乱数）に戻す": "Back to the first take (initial random numbers)",
  "最初": "First",
  "ピッチのずれ": "Pitch offset",
  "抑揚の強さ": "Inflection depth",
  "ビブラートの強さ": "Vibrato depth",
  "テンション": "Edge",
  "張る": "Tense",
  "緩む": "Relaxed",
  "ブレシネス": "Breath",
  "息が多い": "Breathy",
  "息が少ない": "Clear",
  "ジェンダー": "Formant",
  "男性的": "Deeper",
  "女性的": "Brighter",
  "有声度": "Voicing",
  "有声": "Voiced",
  "無声": "Unvoiced",
  "子音の強さ": "Consonants",
  "強い": "Strong",
  "弱い": "Weak",
  "響き": "Ring",
  "響く": "Ringing",
  "こもる": "Muffled",
  "うなり": "Growl",
  "なし": "None",
  "表示/非表示": "Show/hide",
  "クリックで前面に表示（編集できるのは最前面の曲線）": "Click: bring to front (you draw on the front curve)",
  "パラメータを選び直す": "Change parameter",
  "この曲線を閉じる": "Close this curve",
  "曲線を追加": "Add a curve",
  "鉛筆": "Pencil",
  "直線": "Line",
  "消しゴム（右ドラッグでも消せる）": "Eraser (right-drag also erases)",
  "ドラッグ: 最前面の曲線を描く　右ドラッグ: 消去（初期値に戻す）　タブ名をクリックで前面に表示": "Drag: draw the front curve　Right-drag: erase (back to default)　Click a tab name to bring it to the front",
  "NSF-HiFiGAN では効きません": "No effect with NSF-HiFiGAN",
  "ドラッグ: ピッチの線を描く（ピッチのずれに書き込む）　右ドラッグ: 消去して元に戻す": "Drag: draw the pitch line (writes Pitch offset)　Right-drag: erase back to the original",
  "ドラッグ: トラックの範囲を変更（範囲の外の音符は歌わない、端をまたぐ音符は端で切れる）　⌥: スナップしない": "Drag: resize the track range (notes outside aren't sung; notes across the edge are cut)　⌥: no snap",
  "ドラッグ: 長さを変更": "Drag: change length",
  "ドラッグ: 移動（Shift で選択に追加）　ダブルクリック: 歌詞を入力": "Drag: move (Shift adds to selection)　Double-click: enter lyrics",
  "ドラッグ: 音符を描く": "Drag: draw a note",
  "ドラッグ: 範囲選択　ホイール: 上下　Shift+ホイール: 左右　⌘+ホイール: 横の拡大　⌥+ホイール: 縦の拡大": "Drag: box select　Wheel: up/down　Shift+wheel: sideways　⌘+wheel: horizontal zoom　⌥+wheel: vertical zoom",
  "プロジェクトのファイルとして読めません（JSON ではない）": "Not a readable project file (not JSON)",
  "この SVS のプロジェクトのファイルではありません": "Not a project file of this SVS",
  "新しいバージョン（{v}）で保存されたファイルです。アプリを更新してください": "Saved by a newer version ({v}). Please update the app",
  "歌のトラックがありません": "There is no vocal track",
  "（中身が保存したときと違います）": " (content differs from when it was saved)",
  "zip として読めません": "Not a readable zip",
  "zip の目次が壊れています": "The zip directory is corrupted",
  "圧縮された zip には対応していません（{name}）": "Compressed zips are not supported ({name})",
  "zip の中に project.svsproj がありません": "project.svsproj is missing from the zip",
  "解析に失敗: {e}": "Analysis failed: {e}",
  "合成に失敗: {e}": "Synthesis failed: {e}",
  "エンジンとの通信に失敗: {e}": "Couldn't reach the engine: {e}",
  "メロディ": "Melody",
  "MusicXML として読めません（XML が壊れています）": "Not readable as MusicXML (broken XML)",
  "<part> がありません": "No <part> found",
  "{all} パートのうち、歌詞のある {n} パートを読みました": "Read {n} of {all} parts (those with lyrics)",
  "声部が {n} つあります（未対応）。全部つなげて読むので譜面と違う音になります": "{n} voices found (not supported). They are read in sequence, so the result differs from the score",
  "<backup>/<forward> があります（未対応）。時刻がずれます": "<backup>/<forward> found (not supported). Timing will be off",
  "繰り返し記号があります（未対応）。展開せず、書かれた順に 1 回だけ歌います": "Repeats found (not supported). They are sung once, as written",
  "divisions が途中で変わります（未対応）。最初の値を使います": "divisions changes midway (not supported). Using the first value",
  "テンポが途中で変わります（未対応）。最初の値 {bpm} を使います": "Tempo changes midway (not supported). Using the first value, {bpm}",
  "テンポの指定がありません。120 とみなします": "No tempo given. Assuming 120",
  ".mxl の中に楽譜の XML が見つかりません": "No score XML found in the .mxl",
  "読める楽譜は UST と MusicXML（.musicxml・.xml・.mxl）です: {name}": "Readable scores are UST and MusicXML (.musicxml, .xml, .mxl): {name}",
  "歌い手と声": "Singer & voice",
  "エフェクター": "Effects",
  "レンダリング": "Rendering",
  "{n} つ有効": "{n} on",
  "エンジン未接続": "Engine not connected",
  "{done}/{all} フレーズ": "{done}/{all} phrases",
  "完了": "Done",
  "歌い手": "Singer",
  "モデル": "Model",
  "日本語": "Japanese",
  "韓国語": "Korean",
  "「{name}」を鳴らせません: {e}": "Cannot play “{name}”: {e}",
  "「{name}」のエフェクトを掛けられません: {e}": "Cannot apply the effects of “{name}”: {e}",
  "{sec} 秒からのフレーズに不正な値が {n} 個ありました（無音に置き換えて再生します）": "The phrase at {sec} s had {n} invalid samples (played as silence)",
  "ボコーダ": "Vocoder",
  "NSF-HiFiGAN は調波・雑音の分岐を持たないため、音量とうなり以外は効きません。": "NSF-HiFiGAN has no harmonic/noise branches, so only Volume and Growl take effect.",
  "声の調整": "Voice",
  "ダブルクリックで元に戻す": "Double-click to reset",
  "解析完了": "Analyzed",
  "合成中": "Rendering",
  "失敗": "Failed",
  "フレーズ {i}": "Phrase {i}",
  "エンジンは未接続です（モック）。フレーズごとの計算の状況がここに並びます。": "The engine isn't connected (mock). Per-phrase progress will be listed here.",
  "未計算": "Not computed",
  "藤": "Wisteria",
  "夜桜": "Night sakura",
  "氷": "Ice",
  "墨": "Ink",
  "設定（言語・アクセントカラー・mel の配色）": "Settings (language, accent color, mel colormap)",
  "ファイル ▾": "File ▾",
  "トラック": "Tracks",
  "トラックを追加（歌・伴奏）": "Add a track (vocal or backing)",
  "スナップ": "Snap",
  "スナップ 自動": "Snap: Auto",
  "1 小節": "1 bar",
  "1/8 の 3 連": "1/8 triplet",
  "スナップなし": "No snap",
  "WAV に書き出す": "Export to WAV",
  "上下にドラッグ: トラック一覧の高さを変更（ダブルクリック: 全トラックが収まる高さ）": "Drag up/down: resize the track list (double-click: fit all tracks)",
  "再生": "Play",
  "サイドバーの表示/非表示": "Show / hide the sidebar",
  "停止して先頭に戻る": "Stop and return to start",
  "ループ（今後対応予定）": "Loop (coming later)",
  "クリック: テンポを変更": "Click: change tempo",
  "クリック: 拍子を変更": "Click: change time signature",
  "再生位置を追う": "Follow the playhead",
  "クリック: ここにブレスを入れる": "Click: add a breath here",
  "クリック: 別のブレスに替える　右クリック: 消す": "Click: switch to another breath　Right-click: remove",
  "ブレス": "Breaths",
  "すべてに入れる": "Add to all",
  "すべて消す": "Remove all",
  "ブレスの合成に失敗: {e}": "Breath synthesis failed: {e}",
  "この歌い手にはブレスの素材がありません。": "This singer has no breath samples.",
  "音素のタイミングの「+ br」をクリックしても 1 つずつ入れられます（直前の音符から 0.1 秒以上空いた音符の前）。": "You can also add them one by one by clicking “+ br” in the phoneme timing panel (before a note that starts 0.1 s or more after the previous one).",
};
